<div class="h-full">
  <div class="solution flex flex-col gap-4 p-5 overflow-auto h-full" [appLoading]="store.isShowLoadingSpinner()">
    <div class="flex justify-between items-center">
      <div class="solution-title">
        <h2 class="text-xl font-semibold solution-texting">Available Solutions</h2>
      </div>

      @if (store.filteredSolutionsByCategory().length) {
        <div class="solution-unselect-btn clear-all-wrapper">
          <p-button
            class="unselect-btn"
            label="Unselect All"
            (onClick)="unselectAllSolutions()"
            [disabled]="!store.isEnableUnselectAllBtn() || store.isAllSolutionDisabled()"
            [ngClass]="{ 'unselect-btn-disabled': !store.isEnableUnselectAllBtn() || store.isAllSolutionDisabled() }"
          />
        </div>
      }
    </div>

    @if (store.filteredSolutionsByCategory().length) {
      <ng-container>
        <ng-container *ngTemplateOutlet="availableSolutions; context: { solution: store.filteredSolutionsByCategory() }"></ng-container>
      </ng-container>
    } @else {
      <div class="empty-data">
        <h3 class="title">No Data yet</h3>
        <span>Once a challenge is selected, you will see data here</span>
      </div>
    }
  </div>
</div>

<ng-template #availableSolutions let-solution="solution">
  <div class="overflow-auto h-px min-[1400px]:flex-1 max-[1400px]:h-[60vh]">
    @for (solution of store.filteredSolutionsByCategory(); track solution.category) {
      <div class="solution-block">
        <div class="solution-header pb-3">
          <h3 class="solution-block_header uppercase font-bold text-xs inline-block">{{ solution.category }}</h3>
        </div>
        <div class="flex gap-3 flex-wrap mt-3">
          @for (item of solution.compatibilities; track item.availableSolution.name) {
            <div class="solution-item" [ngClass]="{ 'selected-solution': item.isChecked }">
              @let isRelevantTag = item.compatibilityValue?.name === compatibilityValueTypes.NotRelevant;
              <div class="image-container" [ngClass]="{ 'solution-disabled': isNotCompatible(item) }">
                <img src="assets/halliburton_select_solution.jpg" alt="solution-img" class="solution-item_img" />
                @if (!isNotCompatible(item)) {
                  <div class="circle-overlay center-flex">
                    <input
                      type="checkbox"
                      [id]="'checkbox-' + item.availableSolution.name"
                      [name]="item.availableSolution.name"
                      class="circle-overlay-front center-flex"
                      (change)="onCheckboxChange(item)"
                      [checked]="item.isChecked"
                      [ngClass]="{ 'checkbox-disabled': store.isAllSolutionDisabled() }"
                    />
                  </div>
                }
              </div>
              <div class="flex flex-col gap-1 p-2">
                <h4 class="solution-item_name font-bold text-sm leading-4" [title]="item.availableSolution.name">
                  {{ item.availableSolution.name }}
                </h4>
                <div class="h-[20px]">
                  @if (item.compatibilityValue && !isRelevantTag) {
                    <div class="solution-item_tag" [ngStyle]="{ 'background-color': item.compatibilityValue.hexColor }">
                      <i [ngClass]="getSolutionIcon(item)" [title]="this.formatSolutionMessages(item.message)" tooltipPosition="bottom"></i>
                      <h3 class="tag-name">{{ item.compatibilityValue.name }}</h3>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
